import React, { useState } from 'react';
import { FC } from 'react';
import { Icons } from '@components/Icon';
import { IconTemplate } from '@components/Icon/IconTemplate';
import useCart from '@hooks/useCart';
import useTranslations from '@hooks/useTranslation';
import ButtonTemplate from '@ui/Button/Button';
import ContentTemplate from '@ui/Content/Content';
import PackageTemplate from '@ui/Package/Package';
import Title from '@ui/SectionTitle/Title';
import { publicAssets } from '@utils/url.utils';
import { SUBSCRIPTION_PACKAGES } from '../../constants/packages';
import {
    Background,
    Description,
    Package,
    PackageDescriptionItem,
    PackageDescriptionList,
    PackageImage,
    PackageLabel,
    PackagePrice,
    PreTitle,
    PackagePriceWithoutVat,
    PackagePriceSection,
    PackageTitle,
    Packages,
} from './Packages.elements';

export interface PackagesProps {}

const PackagesTemplate: FC<PackagesProps> = () => {
    const { t } = useTranslations();

    const { addOrUpdateItemInCart } = useCart();

    return (
        <Background>
            <PreTitle>{t('packages.intro.label')}</PreTitle>
            <ContentTemplate mobileSidePadding={20}>
                <Title isBlack>{t('packages.intro.title')}</Title>
                <Description>{t('packages.intro.description')}</Description>
            </ContentTemplate>
            <ContentTemplate mobileSidePadding={20}>
                <Title isBlack>{t('packages.title')}</Title>
                <Packages>
                    {SUBSCRIPTION_PACKAGES.map((subscriptionPackage, subscriptionPackageKey) => (
                        <Package key={subscriptionPackageKey}>
                            <PackageImage src={publicAssets(`/${subscriptionPackage.key}.png`)} />
                            <PackageTitle href={subscriptionPackage?.redirectLink}>
                                <PackageTemplate symbol={subscriptionPackage.icon} color={subscriptionPackage.color} />{' '}
                                {subscriptionPackage.title}
                            </PackageTitle>
                            <PackageLabel>{t('packages.label1')}</PackageLabel>
                            <PackageLabel>{t('packages.label2')}</PackageLabel>
                            <PackageDescriptionList>
                                {subscriptionPackage.benefits.map((benefit, benefitKey) => (
                                    <PackageDescriptionItem key={benefitKey}>
                                        <IconTemplate name={Icons.CheckThin} />
                                        <span dangerouslySetInnerHTML={{ __html: benefit }} />
                                    </PackageDescriptionItem>
                                ))}
                            </PackageDescriptionList>
                            <PackagePriceSection>
                                <PackagePrice>{subscriptionPackage.priceWithoutVat} Kč bez DPH / rok</PackagePrice>
                            </PackagePriceSection>
                            <PackagePriceSection>
                                <PackagePriceWithoutVat>
                                    {subscriptionPackage.price} Kč s DPH / rok
                                </PackagePriceWithoutVat>
                            </PackagePriceSection>
                            <ButtonTemplate
                                marginTop={20}
                                marginBottom={20}
                                text={t('packages.package.button')}
                                onClick={() => addOrUpdateItemInCart(subscriptionPackage.moduleId, 1)}
                            />
                        </Package>
                    ))}
                </Packages>
            </ContentTemplate>
        </Background>
    );
};

export default PackagesTemplate;
